import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { UsersListsServiceRB } from 'rainbow-web-sdk/services/users/usersLists.service';

export class UsersListsPlugin extends Plugin {
    public static initialize(): UsersListsPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[UsersListsPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[UsersListsPlugin] initialized");
            window.rainbow.plugins[UsersListsPlugin.name] = new UsersListsPlugin();
            UsersListsServiceRB.getInstance();
        }
        return window.rainbow.plugins[UsersListsPlugin.name];
    }

    private constructor() {
        super();
    }
}
